import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import { ToastService } from "src/app/services/toast.service";

@Component({
  selector: "app-useraccountlockform",
  templateUrl: "./useraccountlockform.component.html",
  styleUrls: ["./useraccountlockform.component.scss"],
})
export class UseraccountlockformComponent implements OnInit {
  userid: any;
  dataSource: any;
  paginator: any;
  userList: any;
  created_By: any;
  displayedColumns: string[] = ["isLock"];

  public Type = {
    isUnlock: false,
  };

  User = new FormGroup({
    userId: new FormControl(),
    userName: new FormControl(),
    firstName: new FormControl(),
    lastName: new FormControl(),
    gender: new FormControl(),
    email: new FormControl(),
    countryCode: new FormControl(),
    mobile: new FormControl(),
    isSuperAdmin: new FormControl(),
    role: new FormControl(),
    token: new FormControl(),
    isActive: new FormControl(),
    isLock: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  constructor(
    private daoService: DaoService,
    private fb: FormBuilder,
    private token: LstorageService,
    public dialogRef: MatDialogRef<UseraccountlockformComponent>,
    private toast: ToastService
  ) {
    this.daoService.getUserList().subscribe((data: any) => {
      this.daoService.defaultUserList(data);
      this.daoService.finalUserList.subscribe(
        (userList) => (this.userList = userList)
      );
      this.dataSource = new MatTableDataSource(this.userList);
      this.dataSource.paginator = this.paginator;
    });

    this.daoService.fuserId.subscribe((data: any) => {
      this.userid = data;
    });

    this.daoService.isUnlock.subscribe((data: any) => {
      this.Type.isUnlock = data;
    });
  }

  ngOnInit() {}
  lock() {
    this.User.value.userId = this.userid;
    this.User.value.isLock = true;
    this.User.value.isActive = true;
    this.User.value.isSuperAdmin = true;
    this.User.value.createdOn = "2019-10-05T03:47:43.629Z";
    this.User.value.modifiedOn = "2019-11-04T18:38:21.751Z";
    this.daoService.lockUser(this.User.value).subscribe((data: any) => {
      if (data.isSuccess) {
        this.daoService.dynamiclockUserList(data.data);
        this.dialogRef.close();
        this.toast.openSnackBar("User locked successfully", "close");
      }
    });
  }

  unlock() {
    this.User.value.userId = this.userid;
    this.User.value.isLock = false;
    this.User.value.isActive = true;
    this.User.value.isSuperAdmin = true;
    this.User.value.createdOn = "2019-10-05T03:47:43.629Z";
    this.User.value.modifiedOn = "2019-11-04T18:38:21.751Z";
    this.daoService.lockUser(this.User.value).subscribe((data: any) => {
      if (data.isSuccess) {
        this.daoService.dynamiclockUserList(data.data);
        this.dialogRef.close();
        this.toast.openSnackBar("User unlocked successfully", "close");
      }
    });
  }

  closedialog() {
    this.dialogRef.close();
  }
}
